<h1 mat-dialog-title class="no-margin">Lista Competenze<mat-icon class="close-icon"
                                                                 (click)="onNoClick()">close</mat-icon></h1>
<div class="container" *ngIf="listaCompetenze">
  <div class="margin-bottom-20">
    <mat-list>
      <mat-list-item *ngFor="let item of listaCompetenze; let  i = index" matTooltip="{{item.descrizione}}">
        {{i+1}}. {{item.descrizione}}
      </mat-list-item>
    </mat-list>
  </div>

</div>
